// todo https://boost.allnetru.dev/api/documentation/partner#/Landings
import { createApi } from '@reduxjs/toolkit/query/react';
import { GetLandingsFilterOptionsResponse, GetLandingsOptionsResponse } from './models';
import { FiltersParams } from '../models';
import { getQueryStringFromParams } from 'lib.shared/src/utils';
import { LANDINGS_TAGS } from '../tags';
import { baseQueryWithReauth } from '../main/baseQueryWithReauth';
import { OrganizationRole } from '../main/organization/organizationType';
const landingPages = LANDINGS_TAGS.LANDINGS_PAGES;

export const landingPagesApi = createApi({
  reducerPath: landingPages,
  baseQuery: baseQueryWithReauth,
  tagTypes: [LANDINGS_TAGS.LANDINGS_PAGES],
  endpoints: (build) => ({
    getLandingsOptions: build.query<
      GetLandingsOptionsResponse,
      { role?: OrganizationRole | 'none'; filters?: FiltersParams }
    >({
      query: ({ filters, role }) => {
        const parts: string[] = [];
        parts.push(getQueryStringFromParams(filters?.events, 'events'));
        parts.push(getQueryStringFromParams(filters?.partners, 'partners'));
        parts.push(getQueryStringFromParams(filters?.campaigns, 'campaigns'));
        parts.push(getQueryStringFromParams(filters?.landings, 'landings'));
        parts.push(getQueryStringFromParams(filters?.statuses, 'statuses'));

        if (filters?.search && filters.search.length > 2) {
          parts.push(`filters[search]=${encodeURIComponent(filters.search)}`);
        }
        if (filters?.dateFrom) {
          parts.push(`filters[date][from]=${encodeURIComponent(filters.dateFrom)}`);
        }
        if (filters?.dateTo) {
          parts.push(`filters[date][to]=${encodeURIComponent(filters.dateTo)}`);
        }
        if (filters?.gap) {
          parts.push(`filters[gap]=${encodeURIComponent(filters.gap)}`);
        }
        if (filters?.breakdown) {
          parts.push(`filters[breakdown]=${encodeURIComponent(filters.breakdown)}`);
        }
        if (filters?.page) {
          parts.push(`page=${encodeURIComponent(filters.page)}`);
        }

        const queryString = parts.filter(Boolean).join('&');

        return {
          url: `/${role || 'partner'}/landings${queryString.length ? `?${queryString}` : ''}`,
        };
      },
      providesTags: [LANDINGS_TAGS.LANDINGS_PAGES],
    }),
    getLandingsFilterOptions: build.query<
      GetLandingsFilterOptionsResponse,
      {
        role?: OrganizationRole | 'none';
        filters?: FiltersParams;
        search?: string;
      }
    >({
      query: ({ filters, role, search }) => {
        const params = new URLSearchParams();

        const relationsQuery = [
          getQueryStringFromParams(filters?.events, 'events', 'relations'),
          getQueryStringFromParams(filters?.campaigns, 'campaigns', 'relations'),
          getQueryStringFromParams(filters?.partners, 'partners', 'relations'),
          getQueryStringFromParams(filters?.landings, 'landings', 'relations'),
        ]
          .filter(Boolean)
          .join('&');

        if (relationsQuery) {
          new URLSearchParams(relationsQuery).forEach((value, key) => {
            params.append(key, value);
          });
        }

        if (typeof filters?.page === 'number') {
          params.append('page', filters.page.toString());
        }

        if (search) {
          params.append('search', search);
        }

        const normalizedRole = role || 'partner';
        const queryString = params.toString();

        return {
          url: `/${normalizedRole}/landings/filter${queryString.length ? `?${queryString}` : ''}`,
        };
      },
      providesTags: [LANDINGS_TAGS.LANDINGS_PAGES],
    }),
  }),
});

export const { useGetLandingsOptionsQuery, useGetLandingsFilterOptionsQuery } = landingPagesApi;
